import { Component, AfterViewInit } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Document } from 'src/app/shared/models/document';
import { AbstractForm } from '../../utils/abstract-form';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { API } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';

@Component({
  selector: 'app-realestate',
  templateUrl: './realestate.component.html',
  styleUrls: ['./realestate.component.scss']
})
export class RealestateComponent extends AbstractForm implements AfterViewInit {

  init = false;

  submitted = false;
  sended = false;

  constructor( 
    public gs : GeneralService,
    protected formBuilder: FormBuilder,
    logger: LoggerService,
    protected httpService: HttpService
  ) {

    super(formBuilder, logger);

  }

  ngAfterViewInit(){
    setTimeout(() => this.init = true,200);
  }

  buildFormGroup(): FormGroup {

    return this.formBuilder.group({
      company_document: ['', [Validators.required, Document.validate('cnpj')]],
    });
  }

  updateControls() { }
  updateObject(): any { }

  sendRealestate() {
    //API.general.help.report
    let user:any = this.gs.getProfiledata();
    let values:any = this.getFormValues();

    values.name = user?.person_name;
    values.email = user?.email;
    values.cellphone = user?.cellphone;
    values.source_action = 'cadastro';
    values.source = 'web';
    
    this.httpService.post<any>(API.general.leadRealestate, values)
      .then(result => {
        this.formGroup.reset();
        this.sended = true;
      })
      .catch((err) => this.gs.error(err))
      .finally(() => {
        this.submitted = false;
      });
  }


}